export const siteConfig = {
  brandName: "Beautify Ourselves",
  siteUrl: "https://beautifyourselves.com",
  currency: "GBP",
  commerceEnabled: false,
  prelaunchNotice: "Coming soon — orders are not currently available.",
  delivery: {
    uk: {
      estimate: null,
      notice:
        "UK delivery times and charges will be confirmed before ordering opens. Delivery is charged separately from the product preview price.",
      shipping:
        "A delivery charge will apply. The confirmed charge and full order total will be shown before payment when checkout is enabled."
    },
    ireland: {
      estimate: null,
      notice:
        "Republic of Ireland ordering is not available. Eligibility, delivery and any import charges have not been confirmed.",
      shipping:
        "Ireland ordering remains closed until eligibility, delivery and import charges are confirmed."
    }
  }
} as const;
